import { CoreFormFieldText } from '../fields/CoreFormFieldText';
import { FormFieldContainer } from '../layout/FormFieldContainer';
import type { ContextFormFieldBaseProps } from './ContextFormFieldBaseProps';
import type { FormFieldControllerRulesProps } from './FormFieldController';
import { FormFieldController } from './FormFieldController';

export const ContextFormFieldText = ({
  fieldPath,
  rules,
  disabled,
  label,
  inline,
  placeholder,
  helperText,
  colSpan,
}: ContextFormFieldBaseProps) => {
  return (
    <FormFieldController
      name={fieldPath}
      rules={rules as FormFieldControllerRulesProps}
    >
      {({ field, fieldState }) => (
        // TODO: A few usages of context fields use FormFieldContainer for layout and
        // we want to decouple external layout from field implementation as core fields
        // are moved to component library. We can remove this as we rework layout
        // of forms that use context fields.
        <FormFieldContainer colSpan={colSpan}>
          <CoreFormFieldText
            label={rules?.required ? `${label} *` : label}
            error={fieldState.error?.message?.toString()}
            inputProps={{
              id: fieldPath,
              ...field,
              disabled,
              placeholder,
              'data-testid': fieldPath,
            }}
            inline={inline}
            helperText={helperText}
          />
        </FormFieldContainer>
      )}
    </FormFieldController>
  );
};
